// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2DdQc","large":"styles_large__LCedD"};